export interface NpcByItem {
  item: {
    id: number | null;
    sku: string;
    upc: string;
    mpn: string;
    brand: string;
    description: string;
  };
  profitCenters: string[];
  markets: any[];
  locationIds: number[];
  locations: any[];
  byMonth: any[];
  total: any;
}

export interface INpcByItemHeader {
  setDiff: any;
  setSelected: any;
  location: any;
  setLocation: any;
}

export interface NpcByItemPayload {
  itemId: number;
  markets: string[];
  locations: number[];
}

interface SearchNsItemsAction {
  type: NpcByItemActionTypes.SEARCH_NS_ITEMS;
  payload: any[];
}

interface SetSearchNsItemsLoadingAction {
  type: NpcByItemActionTypes.SET_SEARCH_NS_ITEMS_LOADING;
}

interface GetNpcByItemAction {
  type: NpcByItemActionTypes.GET_NPC_BY_ITEM;
  payload: NpcByItem;
}

interface SetNpcByItemLoadingAction {
  type: NpcByItemActionTypes.SET_NPC_BY_ITEM_LOADING;
}

interface ClearNpcByItemAction {
  type: NpcByItemActionTypes.CLEAR_NPC_BY_ITEM;
}
interface ClearNpcMarketsAction {
  type: NpcByItemActionTypes.CLEAR_NPC_MARKETS;
}

export enum NpcByItemActionTypes {
  SEARCH_NS_ITEMS = 'SEARCH_NS_ITEMS',
  SET_SEARCH_NS_ITEMS_LOADING = 'SET_SEARCH_NS_ITEMS_LOADING',
  GET_NPC_BY_ITEM = 'GET_NPC_BY_ITEM',
  SET_NPC_BY_ITEM_LOADING = 'SET_NPC_BY_ITEM_LOADING',
  CLEAR_NPC_BY_ITEM = 'CLEAR_NPC_BY_ITEM',
  CLEAR_NPC_MARKETS = 'CLEAR_NPC_MARKETS'
}

export interface NpcByItemState {
  searchItems: any[];
  byItem: NpcByItem;
  byItemConst: {
    markets: any[];
    locations: any[];
    getData: boolean;
  };
  loading: boolean;
  searchLoading: boolean;
}

export type NpcByItemAction =
  | SetNpcByItemLoadingAction
  | SetSearchNsItemsLoadingAction
  | SearchNsItemsAction
  | GetNpcByItemAction
  | ClearNpcByItemAction
  | ClearNpcMarketsAction;
